var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE1IconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10V0H16L10.5763 5.11111L15.7535 10H0Z",
    fill: "#CACACA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.924V3H5.364V3.588H3.696V4.59H5.106V5.178H3.696V6.336H5.424V6.924H3Z",
    fill: "#1E1E2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17452 6.924V6.36H7.02652V3.852H6.32452V3.42C6.51252 3.384 6.67652 3.342 6.81652 3.294C6.95652 3.242 7.08652 3.18 7.20652 3.108H7.72252V6.36H8.47252V6.924H6.17452Z",
    fill: "#1E1E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE1IconMenu);
export default __webpack_public_path__ + "static/media/e1-icon-menu.91560790db2c5fa35c3666ecf8e6844a.svg";
export { ForwardRef as ReactComponent };